import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import SiHaDocumentationStatusApi from '../generated/api/SiHaDocumentationStatus';

export default (service: Servicelayer) => ({
  ...SiHaDocumentationStatusApi(service),

  // Add custom calls here

});
